import { FormValidation } from "@lib/types/form";
import { Validator } from "../Validator";

const cigRegisterValidators = {
  socialMediaHandle: (validation: FormValidation, value: any) =>
    new Validator(validation, value).exists().is("string").length.lessThanOrEqualTo(100),
  subCategory: (validation: FormValidation, value: any) =>
    new Validator(validation, value).exists().is("string"),
  country: (validation: FormValidation, value: any) =>
    new Validator(validation, value).exists().is("string"),
  twitchHandle: (validation: FormValidation, value: any) =>
    new Validator(validation, value).exists().is("string"),
};

export default cigRegisterValidators;
